import { render, staticRenderFns } from "./CollapsibleContent.vue?vue&type=template&id=5c6ec360&scoped=true&"
import script from "./CollapsibleContent.vue?vue&type=script&lang=js&"
export * from "./CollapsibleContent.vue?vue&type=script&lang=js&"
import style0 from "./CollapsibleContent.vue?vue&type=style&index=0&id=5c6ec360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6ec360",
  null
  
)

component.options.__file = "CollapsibleContent.vue"
export default component.exports